import { TextColor } from '@kite-js/theme-types';

const grayScale: TextColor = {
    100: '#F4F6F8',
    300: '#4F6F8F',
    500: '#001833',
    800: '#000000',
};

export default grayScale;
